//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TitleConfig } from '@/__configs/config_types';

const titleConfig: TitleConfig = {
  customerLabel: 'vendor'
};

export default titleConfig;
